/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ea-popover-content[_ngcontent-%COMP%]{max-height:120px;min-width:315px;overflow-x:hidden;overflow-y:auto}.ea-popover-participant[_ngcontent-%COMP%]{height:30px;align-items:center;border-top:1px solid #e6e6e6}.ea-popover-participant[_ngcontent-%COMP%]:first-child{border-top:none}.ea-popover-participant[_ngcontent-%COMP%]   .fa-times[_ngcontent-%COMP%]{padding:4px 5px;font-size:12px}"];
export { styles as styles };
